import React, { useState, useEffect } from 'react';
import styles from '@/pages/camp/components/css/campCSS.less';
import { useRequest } from 'umi';
import { listRewardLog } from '@/utils/requests/camp/requests_admin';
import { RewardLogVO } from '@/types/camp/admin/studentType';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { RewardConditionToText } from '@/pages/camp/util/campState';
import useScrollHeight from '@/hooks/useScrollHeight';

interface Props {
  batchId: string;
  uid: number;
  nodeList: any;
}
const RewardLog: React.FC<Props> = ({ batchId, uid, nodeList }) => {
  const [data, setData] = useState<RewardLogVO[]>([]);
  const [loading, setLoading] = useState(true);
  const scrollHeight = useScrollHeight();

  // 获取接口
  const { run: listRewardLogRequest } = useRequest(
    () => {
      return listRewardLog(batchId, uid);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setData(res);
        setLoading(false);
      },
    },
  );
  useEffect(() => {
    listRewardLogRequest();
  }, []);

  const columns: ColumnsType<RewardLogVO> = [
    {
      title: '奖励名称',
      dataIndex: 'rewardName',
      key: 'rewardName',
    },
    {
      title: '领取条件',
      dataIndex: 'condition',
      key: 'condition',
      render: (value, record) => <RewardConditionToText nodeList={nodeList} condition={value} />,
    },
    {
      title: '领取时间',
      dataIndex: 'createdTime',
      key: 'createdTime',
      width: 150,
      render: (value: any) => (value ? `${dayjs(value).format('YYYY-MM-DD HH:mm')}` : '--'),
    },
  ];
  return (
    <div>
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        className={styles.study_log_table}
        scroll={{ y: scrollHeight }}
      />
    </div>
  );
};
export default RewardLog;
